import { Space } from "antd";
import QR from "qrcode-base64";
import React from "react";

import imgPPLogo from "../../../../assets/img/pp-logo-black.svg";
import { formatCurrency, getDateTime } from "../../../../utils/format";

export const DeliverySlip = ({ data }) => {
  const qrBase64 = QR.drawImg(data?.code ?? "");
  let totalPrice = 0;
  const groupCount = data?.collectiveProducts?.length;
  if (groupCount > 0) {
    data?.collectiveProducts?.forEach((product) => {
      totalPrice += product?.totalPrice;
    });
    data?.children?.forEach((child) => {
      totalPrice += child?.totalPrice;
    });
  } else {
    data?.warehouseOrders?.forEach((warehouse) => {
      totalPrice = warehouse?.products?.reduce(
        (sum, row) => (sum += row?.totalPrice),
        0
      );
    });

    data?.branchOrders?.forEach((branch) => {
      totalPrice += branch?.products?.reduce(
        (sum, row) => (sum += row?.totalPrice),
        0
      );
    });
  }
  const totalProductUnit = data?.children?.reduce(
    (sum, row) => (sum += row?.totalUnit),
    0
  );
  const totalProductUnitCollective = data?.collectiveProducts?.reduce(
    (sum, row) => (sum += row?.unit),
    0
  );
  const renderBarcode = (barcode) => {
    const result = barcode?.map((barcode) => {
      return (
        <span
          style={{
            fontSize: 11,
            background: "#e5e5e5",
            padding: "2px 5px",
            borderRadius: "6px",
            marginRight: "3px",
          }}
        >
          {" "}
          {barcode}
        </span>
      );
    });
    return result;
  };
  const collectiveStyleTr = {
    color: "#888a99",
  };
  const collectiveStyleTd = {
    fontSize: 12,
  };
  const collectiveStyleTdL = {
    fontSize: 12,
    paddingLeft: 5,
  };
  const renderCollective = (data) => {
    const result = data?.collectiveProducts?.map((product, i) => {
      return (
        <>
          <tr style={{ background: "#37B5E8", color: "#fff"}} key={i}>
            <td>{product?.productSKU || "-"}</td>
            <td>
              {product?.barcodes?.length !== 0
                ? renderBarcode(product?.barcodes)
                : "-"}
            </td>
            <td>{product?.title || "-"}</td>
            <td>
              {product?.totalPrice
                ? `${formatCurrency(
                    parseInt(product?.totalPrice / product?.unit)
                  )} `
                : "-"}
            </td>
            <td style={{ textAlign: "center" }}>{product?.unit || "-"}</td>
            <td>
              {product?.totalPrice
                ? `${formatCurrency(product?.totalPrice)}`
                : "-"}
            </td>
          </tr>
          {product?.groupProducts?.map((item, index) => {
            return (
              <tr style={collectiveStyleTr} key={index}>
                <td style={collectiveStyleTdL}>{item?.productSku || "-"}</td>
                <td>-</td>
                <td style={collectiveStyleTd}>{item?.title || "-"}</td>
                <td style={collectiveStyleTd}>-</td>
                <td style={collectiveStyleTd}>-</td>
                <td style={collectiveStyleTd}>-</td>
              </tr>
            );
          })}
        </>
      );
    });
    const child = data?.children?.map((item, key) => (
      <tr key={key}>
        <td>{item?.productSKU || "-"}</td>
        <td>
          {item?.barcodes.length !== 0 ? renderBarcode(item?.barcodes) : "-"}
        </td>
        <td>{item?.productTitle || "-"}</td>
        <td>
          {item?.totalPrice
            ? `${formatCurrency(parseInt(item?.totalPrice / item?.totalUnit))} `
            : "-"}
        </td>
        <td style={{ textAlign: "center" }}>{item?.totalUnit || "-"}</td>
        <td>
          {item?.totalPrice ? `${formatCurrency(item?.totalPrice)} ` : "-"}
        </td>
      </tr>
    ));
    return { result, child };
  };
  return (
    <div style={{padding: '20px'}}>
      <div
        style={{
          display: "flex",
          alignItems: "start",
          borderBottom: "1px solid #E6E6E6",
          paddingBottom: 16,
        }}
      >
        <Space size={60} align="start" style={{ fontSize: 13 }}>
          <Space size={8} direction="vertical">
            <div>
              <div style={{ whiteSpace: "nowrap" }}>Хүлээн авагчийн нэр</div>
              <div style={{ fontWeight: 600, lineHeight: "16px" }}>
                {data?.customerName || "-"}
              </div>
            </div>

            <div>
              <div>Утас</div>
              <div style={{ fontWeight: 600, lineHeight: "16px" }}>
                {data?.customerPhone || "-"}
              </div>
            </div>
          </Space>
          <Space size={8} direction="vertical">
            <div>
              <div style={{ whiteSpace: "nowrap" }}>Захиалгын дугаар</div>
              <div style={{ fontWeight: 600, lineHeight: "16px" }}>
                {data?.code || "-"}
              </div>
            </div>

            <div>
              <div>Захиалсан</div>
              <div
                style={{
                  fontWeight: 600,
                  lineHeight: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                {data?.createdAt ? getDateTime(data.createdAt) : "-"}
              </div>
            </div>
          </Space>
          <Space size={8} direction="vertical">
            <div>
              <div>Дүүрэг</div>
              <div style={{ fontWeight: 600, lineHeight: "16px" }}>
                {data?.dropoffAddressArray?.length > 2
                  ? `${data.dropoffAddressArray[0]?.name}, ${data.dropoffAddressArray[1]?.name}`
                  : "-"}
              </div>
            </div>

            <div>
              <div>Хороо/Баг</div>
              <div style={{ fontWeight: 600, lineHeight: "16px" }}>
                {data?.dropoffAddressArray?.length > 2
                  ? `${data.dropoffAddressArray[2]?.name}`
                  : "-"}
              </div>
            </div>

            <div>
              <div>Хаяг</div>
              <div style={{ fontWeight: 600, lineHeight: "16px" }}>
                {data?.dropoffDetail || "-"}
              </div>
            </div>
          </Space>
        </Space>
        <img src={imgPPLogo} alt="PickPack" style={{ margin: "-8px 8px 0px 16px" }} />
      </div>

      <table className="del_slip_tbl">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Мерчант код</th>
            <th>Барааны нэр</th>
            <th>Нэгж үнэ</th>
            <th style={{ minWidth: 80 }}>Тоо/Ш</th>
            <th>Дүн</th>
          </tr>
        </thead>
        <tbody>
          {data?.collectiveProducts?.length > 0 ? (
            <React.Fragment>
              {renderCollective(data).result}
              {renderCollective(data).child}
            </React.Fragment>
          ) : (
            <>
              <>
                {data?.warehouseOrders?.map((warehouse) => {
                  return warehouse?.products?.map((item, key) => (
                    <tr key={key}>
                      <td>{item?.productSKU || "-"}</td>
                      <td>
                        {item?.barcodes.length !== 0
                          ? renderBarcode(item?.barcodes)
                          : "-"}
                      </td>
                      <td>{item?.productTitle || "-"}</td>
                      <td>
                        {item?.totalPrice
                          ? `${formatCurrency(
                              parseInt(item?.totalPrice / item?.totalUnit)
                            )} `
                          : "-"}
                      </td>
                      <td>{item?.totalUnit || "-"}</td>
                      <td>
                        {item?.totalPrice
                          ? `${formatCurrency(item?.totalPrice)}`
                          : "-"}
                      </td>
                    </tr>
                  ));
                })}
              </>
              {data?.branchOrders?.map((branch) => {
                return branch?.products?.map((item, i) => (
                  <tr key={i}>
                    <td>{item?.productSKU || "-"}</td>
                    <td>
                      {item?.barcodes.length !== 0
                        ? renderBarcode(item?.barcodes)
                        : "-"}
                    </td>
                    <td>{item?.productTitle || "-"}</td>
                    <td>
                      {item?.totalPrice
                        ? `${formatCurrency(
                            parseInt(item?.totalPrice / item?.totalUnit)
                          )} `
                        : "-"}
                    </td>
                    <td>{item?.totalUnit || "-"}</td>
                    <td>
                      {item?.totalPrice
                        ? `${formatCurrency(item?.totalPrice)} `
                        : "-"}
                    </td>
                  </tr>
                ));
              })}
            </>
          )}
          <tr className="del_slip_tbl_sum_row">
            <td rowSpan={3} colSpan={3} style={{ verticalAlign: "top" }}>
              <div style={{ display: "flex" }}>
                <div style={{ fontSize: 12, maxWidth: 280 }}>
                  <div style={{ fontWeight: 600 }}>Нэмэлт мэдээлэл</div>
                  <div style={{ marginTop: 8 }}>
                    {data?.orderDescription || "-"}
                  </div>
                </div>
                <div style={{ fontSize: 12, marginLeft: 74, maxWidth: 280 }}>
                  <div style={{ fontWeight: 600 }}>
                    Анхаарах шаардлагатай зүйлс
                  </div>
                  <div style={{ marginTop: 8 }}>
                    {data?.notes?.join(", ") || "-"}
                  </div>
                </div>
              </div>
            </td>
            <td>Нийт тоо/ш:</td>
            <td style={{ fontWeight: 700, textAlign: "center" }}>
              {totalProductUnit + (totalProductUnitCollective || 0) || 0}
            </td>
            <td></td>
          </tr>
          {/* <tr className="del_slip_tbl_sum_row">
            <td>Хүргэлт</td>
            <td style={{ fontWeight: 700 }}>0 ₮</td>
          </tr> */}
          <tr className="del_slip_tbl_sum_row">
            <td style={{ fontWeight: 700 }}>Нийт дүн:</td>
            <td></td>
            <td style={{ fontWeight: 700 }}>
              {totalPrice ? `${formatCurrency(totalPrice)}` : 0}
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ fontWeight: 600, fontSize: 12, textAlign: "center" }}>
        Танд Баярлалаа!
      </div>
      <div
        style={{
          borderBottom: "1px dashed #000",
          width: "100%",
          marginTop: 18,
          marginBottom: 18,
        }}
      ></div>

      <Space size={12} align="start" style={{ fontSize: 13 }}>
        <img
          src={qrBase64}
          alt="QR код"
          style={{ height: 128, width: 128, marginRight: 16 }}
        />
        <Space size={8} direction="vertical">
          <div>
            <div style={{ whiteSpace: "nowrap" }}>Хүлээн авагчийн нэр</div>
            <div style={{ fontWeight: 600, lineHeight: "16px" }}>
              {data?.customerName || "-"}
            </div>
          </div>

          <div>
            <div>Утас</div>
            <div style={{ fontWeight: 600, lineHeight: "16px" }}>
              {data?.customerPhone || "-"}
            </div>
          </div>
        </Space>
        <Space size={8} direction="vertical">
          <div>
            <div style={{ whiteSpace: "nowrap" }}>Захиалгын дугаар</div>
            <div style={{ fontWeight: 600, lineHeight: "16px" }}>
              {data?.code || "-"}
            </div>
          </div>

          <div>
            <div>Захиалсан</div>
            <div
              style={{
                fontWeight: 600,
                lineHeight: "16px",
                // whiteSpace: "nowrap",
              }}
            >
              {data?.createdAt ? getDateTime(data.createdAt) : "-"}
            </div>
          </div>
        </Space>
        <Space size={8} direction="vertical">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <div>Хот, дүүрэг</div>
              <div style={{ fontWeight: 600, lineHeight: "16px" }}>
                {data?.dropoffAddressArray?.length > 2
                  ? `${data.dropoffAddressArray[0]?.name}, ${data.dropoffAddressArray[1]?.name}`
                  : "-"}
              </div>
            </div>
            <img
              src={imgPPLogo}
              alt="PickPack"
              style={{ margin: "-8px 8px 0px 16px" }}
            />
          </div>

          <div>
            <div>Хороо/Баг</div>
            <div style={{ fontWeight: 600, lineHeight: "16px" }}>
              {data?.dropoffAddressArray?.length > 2
                ? `${data.dropoffAddressArray[2]?.name}`
                : "-"}
            </div>
          </div>

          <div>
            <div>Хаяг</div>
            <div style={{ fontWeight: 600, lineHeight: "16px" }}>
              {data?.dropoffDetail || "-"}
            </div>
          </div>
        </Space>
      </Space>
    </div>
  );
};
